"use client";

import { useEffect, useState } from "react";
import { getCookie, setCookie } from 'cookies-next'
import {useTranslations} from "next-intl";
import { Link } from "@pata/i18n";

export default function CookiePopup() {
    const t = useTranslations('CookiePopup')
    const [open, setOpen] = useState(false);
    
    useEffect(() => {
        setTimeout(() => {
            if (getCookie('cookie_popup') === 'closed') return;
            setOpen(true);
        }, 500);
    }, []);
    
    const acceptCookies = (e: any) => {
        e.preventDefault();
        setOpen(false);
        
        setCookie('cookie_popup', 'closed', { maxAge: 60 * 60 * 24 * 30, path: '/' })
    };
    
    return (
        <div id="cookie-popup" className={open ? "open" : ""}>
            <div className="container">
                <div className="inner-body">
                    <div className="main-text">
                        {t.rich('text', {
                            privacyPolicyLink: (chunks) => <Link href="/privacy-policy">{chunks}</Link>
                        })}
                    </div>
                    <div className="button-body">
                        <Link href={"#"} className="cookie-button" onClick={acceptCookies}>
                            {t('button')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}